import { Component, OnInit } from '@angular/core';

import { ProjectService } from 'src/app/shared/project/project.service';
import { ProjectListItem } from '../shared/project/project-list-item';
import { ImportProgressService } from 'src/app/shared/import/import-progress.service';
import { ImportStep } from '../shared/import/import-step';
import { DataService } from '../shared/network/data.service';

@Component({
  templateUrl: './project-list.component.html',
  styleUrls: ['./project-list.component.scss']
})
export class ProjectListComponent implements OnInit {
    projects: ProjectListItem[] = [];

    dataLoaded = false;

    constructor(private projectService: ProjectService, private importProgressService: ImportProgressService, private dataService: DataService) { }

    ngOnInit(): void {
        this.loadProjects();
        this.importProgressService.clearImportStep();
    }

    async deleteProject(project: ProjectListItem) {
        await this.projectService.deleteProject(project.id);
        const i = this.projects.indexOf(project, 0);
        if (i > -1) {
            this.projects.splice(i, 1);
        }
    }

    async duplicateProject(project: ProjectListItem) {
        await this.projectService.duplicateProject(project.id);
        this.loadProjects();
    }

    private loadProjects(): void {
        this.projectService.getProjectsList().then(res => {
            this.loadUrls(res);
            this.projects = res;
            this.dataLoaded = true;
        });
    }

    renameProj(proj: ProjectListItem) {
        proj.editMode = false;
        this.projectService.renameProject(proj.id, proj.name);
    }

    private loadUrls(items: ProjectListItem[]) : void {
        for (let i = 0; i < items.length; ++i) {
            items[i].url = this.getUrlForProject(items[i]);
            items[i].downloadUrl =  this.dataService.getBaseUrl() + `/projects/export/${items[i].id}`;
        }
    }

    private getUrlForProject(proj: ProjectListItem):string {
        switch (proj.currentStep) {
            case ImportStep.upload:
                return "/reupload";
            case ImportStep.controlColumn:
                return "/select-column-control";
            case ImportStep.outcomeColumn:
                return "/select-column-outcome";
            case ImportStep.dimensions:
                return "/identities";
            case ImportStep.cards:
                return "/cards";
            default:
                return "";
        }
    }
}
